import styled from 'styled-components'

export const CategoriesSwitcherWrapper = styled.div`
  width: 100%;
  padding: 24px 0;
  padding-bottom: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (max-width: 600px) {
    overflow-y: auto;
    justify-content: flex-start;
    padding: 0 12px 0;
    gap: 11px;
  }
`

export const FeaturedButton = styled.button`
  width: 154px;
  height: 44px;
  border: none;
  border-radius: 5px;
  background: ${props => (props.selected ? '#ff5e6d' : '#E5E5E5')};
  color: ${props => (props.selected ? 'white' : 'black')};
  margin: 0 8px;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  @media screen and (max-width: 600px) {
    margin: 0;
    flex-grow: 1;
    height: 32px;
    width: 112px;
    font-size: 13px;
  }
`
